<script>
export default {
	hookZone: ['actions'],
	inject: ['hookContainer'],
	showHook(zoneName, hookContainer) {
		return hookContainer.ProductPage?.product?.info?.customizationKey == 'recetadigital'
	},
	computed: {
		ProductPage() {
			return this.hookContainer()
		},
		product() {
			return this.ProductPage.product
		},
		outOfStock() {
			return this.ProductPage.selectedVariant.stock.availability == 'OutOfStock'
		},
	},
}
</script>

<template>
	<div id="product-actions" class="product-actions-recetadigital">
		<Button
			id="product-buy-btn"
			class="full-width py-5 btn-buy"
			color="cta"
			:disabled="outOfStock || !product.buyable"
			:to="{ name: 'recetadigital' }"
			large
		>
			<v-icon class="font-0 mr-2">mdi-receipt-text</v-icon>
			<span class="font-2">Ir a Receta Digital</span>
		</Button>
	</div>
</template>

<style></style>

